import classNames from "classnames";
import { forwardRef, HTMLAttributes } from "react";

import { colorTypes, Shimmered } from "./Shimmer.styled";

export type ShimmerProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Set shimmer height
   * @default {1}
   */
  height?: string | number;

  /**
   * Set shimmer width
   * @default {1}
   */
  width?: string | number;

  /**
   * Set shimmer border radius
   * @default {8}
   */
  radius?: string | number;

  /**
   * Set color of the shimmer
   * @default {"normal"}
   */
  color?: keyof typeof colorTypes;
};

const defaultProps: ShimmerProps = {
  height: 1,
  width: 1,
  radius: 8,
  color: "normal"
};

const Shimmer = forwardRef<HTMLDivElement, ShimmerProps>((props, ref) => {
  const { className, height, width, radius, color, ...restProps } = props;
  const cardClass = classNames("c-shimmer", className);

  return (
    <Shimmered
      data-testid="qa-shimmer"
      ref={ref}
      className={cardClass}
      height={height}
      width={width}
      radius={radius}
      color={color}
      {...restProps}
    />
  );
});

Shimmer.defaultProps = defaultProps;

export default Shimmer;
